import { ApiClientService } from '@dfl/react-security';
import { format } from 'date-fns';
import fileDownload from 'js-file-download';
import { CommonExport } from '../common/common-export.service';
import { setLastExportId } from 'modules/export/storage/last-export.storage';

export class DispatchExportService extends CommonExport<any> {
  _downloadFileToExcel = (path: string, name?: string) =>
    this.downloadFileToExcel({
      name: name ?? 'products',
      path: `/download/${path}`,
    });

  // inicial path export
  _getExportPath = async (params: any, path?: string) => {
    const response = await this.getExportPath(path ?? '/dispatch/export', params);
    if (response?._id) {
      setLastExportId(response._id);
    }
    return response;
  };

  _generateDownload = () => this.generateDownload('/dispatch/export/');

  /* pre despachos */
  preDispatchSubOrderProviderExportToExcel = (filters: any, search: any, provider: string) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `pre-dispatch-provider-${time}.xlsx`;
    return this._downloadDocument('/excel/pre-dispatch-provider', name, filters, search, provider);
  };

  preDispatchSubOrderExportToXml = (filters: any, search: any, provider: string) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `pre-dispatch-${time}.xml`;
    return this._downloadDocument('/xml/pre-dispatch', name, filters, search, provider);
  };

  exportToDispatchPDF = (filters?: any) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `invoices-dispatch-${time}.pdf`;
    return ApiClientService.post(this.getPath('/pdf3Bulk?admin=true'), { filters }, { responseType: 'blob' }).then(
      ({ data }) => {
        fileDownload(data, name);
      },
    );
  };
}

export default new DispatchExportService('/ms-sales/api');
